import i18n from 'live/services/i18n'

import { IInfoPresenter } from 'plugin-aeapps-resources-manager/shared/api/IInfoPresenter'

import { BasicInfoComponent, IBasicInfo } from './BasicInfoComponent'

export const basicInfoPresenter: IInfoPresenter<IBasicInfo> = {
    presenterCode: '832f85dc-ad80-465d-aa4f-a4f48f0f755c',
    title: i18n('Resource Basic Informations'),
    group: i18n('Resource informations'),
    order: 0,
    component: BasicInfoComponent
}
